import React from 'react';
import { useTranslation } from 'react-i18next';
import SalesTransactionsTab from './SalesTransactionsTab';

const MyBids = () => {
    const { t } = useTranslation(['common']);

    return <SalesTransactionsTab title={t('common:titles.myBids')} onlySelf showFilter />;
};

export default MyBids;
